module.exports = __webpack_public_path__ + "static/media/standUpComedy-min.280a9af6.jpeg";